
















































































































































































import { Component, Watch, Prop, Vue } from 'vue-property-decorator'
/* component */
import PageTitle from '@/app/components/Common/PageTitle.vue'
/* module */
import Local from '@/app/module/local'
import { routerPath, errorFlag } from '@/app/model/store/domain/const'
import CommonClass from '@/app/module/common'
import Session from '@/app/module/session'

@Component({
  components: {
    PageTitle
  }
})
export default class PlantSearch extends Vue {
  private year: number = this.$store.state.plantState.selectedYear
  private season: number = this.$store.state.plantState.selectedSeason
  private isAllPlantings: boolean = this.$store.state.plantState.isAllPlantings
  private word: string = this.$store.state.plantState.searchText
  private seasons: string[] = []
  private yearList: number[] = []

  @Prop() private count!: number

  private doPlantSearch () {
    this.$store.commit('plantState/setSelectedYear', this.year)
    this.$store.commit('plantState/setSelectedSeason', this.season)
    this.$store.commit('plantState/setIsAllPlantings', this.isAllPlantings)
    this.$store.commit('plantState/setSearchText', this.word)

    this.$emit('search-list')
  }

  created () {
    /* yearの配列を作成 */
    const endYear = new Date().getFullYear() + 1
    const constantValue = JSON.parse(Local.getConstantValue()!)
    let minPlantYear = constantValue.min_plant_year
    if (minPlantYear === null) {
      minPlantYear = new Date().getFullYear()
    }
    for (let i = minPlantYear; i <= endYear; i++) {
      this.yearList.unshift(i)
    }
    this.seasons = constantValue.seasons
  }

  private doClear () {
    this.year = 0
    this.season = 0
    this.isAllPlantings = false
    this.word = ''

    /* stateリセット */
    this.$store.commit('plantState/setSelectedYear', this.year)
    this.$store.commit('plantState/setSelectedSeason', this.season)
    this.$store.commit('plantState/setIsAllPlantings', this.isAllPlantings)
    this.$store.commit('plantState/setSearchText', this.word)

    this.$emit('reset-list')
  }
}
